export const MERCHANT_TABLE_HEADINGS = ['Merchant ID', 'Merchant Name', 'Code', 'Country Code', 'Services Enabled', ''];
